"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isPathApi_1 = __importDefault(require("../legacy-editor-package/utils/isPathApi"));
const isPathsGroupNode = (node) => Boolean(node &&
    isPathApi_1.default(node.selected_api) &&
    node.type_of === 'write' &&
    node.action === 'branch');
exports.default = isPathsGroupNode;
